import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RestService } from "./rest.service";
import { ConfigService } from "./utils/config.service";

@Injectable()
export class ActivityLogService extends RestService<any> {
    constructor(configService: ConfigService, http: HttpClient) {
        super('/activities', http, configService);
    }

    generateCsvReport(body: any) {
        return this.makeRequest('post', '/generate-activity-logs-report', body);
    }
}